<footer class="footer">
  <ng-template [ngIf]="!isDisplayingMap">
    <div class="footer-top">
      <div class="footer-container">
        <div class="footer-wrapper">
          <div class="footer-item links">
            <div
              id="c1910"
              class="frame frame-size-default frame-default frame-type-sqi_footer_useful_links frame-layout-default frame-background-none frame-no-backgroundimage frame-space-before-none frame-space-after-none"
            >
              <div class="frame-group-container">
                <div class="frame-group-inner">
                  <div class="frame-container frame-container-default">
                    <div class="frame-inner">
                      <header class="frame-header">
                        <h2 class="element-header">
                          <span>Liens utiles</span>
                        </h2>
                      </header>
                      <ul>
                        <li>
                          <a
                            class=""
                            href="https://www.sqi.gouv.qc.ca/emplois"
                            target=""
                            title="Emplois"
                            >Emplois</a
                          >
                        </li>
                        <li>
                          <a
                            class=""
                            href="https://www.sqi.gouv.qc.ca/a-propos/nous-joindre"
                            target=""
                            title="Nous joindre"
                            >Nous joindre</a
                          >
                        </li>
                        <li>
                          <a
                            class="link-externe"
                            href="https://extranet.sqi.gouv.qc.ca/xnet/"
                            target="_blank"
                            title="Extranet"
                            >Extranet</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-item social-links">
            <h6>Suivez-nous</h6>
            <!--VERSION Québec.ca-->
            <div class="sociallinks-wrapper">
              <ul class="sociallinks-items">
                <li title="Facebook">
                  <a
                    href="https://www.facebook.com/sqiquebec"
                    rel="noopener"
                    target="_blank"
                    ><img
                      class="icon"
                      alt="Facebook"
                      src="/assets/images/social/Facebook.svg"
                  /></a>
                </li>
                <li title="Instagram">
                  <a
                    href="https://www.instagram.com/sqi_quebec"
                    rel="noopener"
                    target="_blank"
                    ><img
                      class="icon"
                      alt="Instagram"
                      src="/assets/images/social/Instagram.svg"
                  /></a>
                </li>
                <li title="LinkedIn">
                  <a
                    href="https://www.linkedin.com/company/societe-quebecoise-des-infrastructures"
                    rel="noopener"
                    target="_blank"
                    ><img
                      class="icon"
                      alt="LinkedIn"
                      src="/assets/images/social/LinkedIn.svg"
                  /></a>
                </li>
                <li title="YouTube">
                  <a
                    href="https://www.youtube.com/@sqivideo"
                    rel="noopener"
                    target="_blank"
                    ><img
                      class="icon"
                      alt="YouTube"
                      src="/assets/images/social/YouTube.svg"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer-item right-block pb-2">
          <div class="footer-contact">
            <span>Société québécoise des infrastructures</span>
          </div>
          <div class="footer-contact">
            <h6>Siège social</h6>
            <p>Édifice Hector-Fabre</p>
            <p>525, boulevard René-Lévesque Est</p>
            <p>Québec (Québec) G1R 5S9</p>
          </div>
          <div class="footer-contact">
            <h6>Bureau de Montréal</h6>
            <p>Édifice Ernest-Cormier</p>
            <p>445, rue Saint-Gabriel</p>
            <p>Montréal (Québec) H2Y 3A2</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div
          id="c1911"
          class="frame frame-size-default frame-default frame-type-sqi_footer_bottom frame-layout-default frame-background-none frame-no-backgroundimage frame-space-before-none frame-space-after-none"
        >
          <div class="frame-group-container">
            <div class="frame-group-inner">
              <div class="frame-container frame-container-default">
                <div class="frame-inner">
                  <ul>
                    <li>
                      <a
                        class=""
                        href="https://www.sqi.gouv.qc.ca/a-propos/acces-a-linformation"
                        target=""
                        title="Accès à l'information"
                        >Accès à l'information</a
                      >
                    </li>
                    <li>
                      <a
                        class=""
                        href="https://www.sqi.gouv.qc.ca/plan-site"
                        target=""
                        title="Plan du site"
                        >Plan du site</a
                      >
                    </li>
                    <li>
                      <a
                        class=""
                        href="https://www.sqi.gouv.qc.ca/a-propos/politique-de-confidentialite"
                        target=""
                        title="Politique de confidentialité"
                        >Politique de confidentialité</a
                      >
                    </li>
                    <li>
                      <a
                        class=""
                        href="https://www.sqi.gouv.qc.ca/a-propos/accessibilite"
                        target=""
                        title="Accessibilité"
                        >Accessibilité</a
                      >
                    </li>
                    <li>
                      <a
                        class="link-externe"
                        href="https://www.quebec.ca/"
                        target="_blank"
                        title="Québec.ca"
                        >Québec.ca</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--FOOTER NAVIGATION_end-->
    <section>
      <div class="footer-meta-container">
        <div class="footer-meta"></div>
        <div class="footer-copyright">
          <div class="footer-logo" lang="fr">
            <a href="https://www.sqi.gouv.qc.ca"
              ><img
                id="logoFooter"
                alt="Société québécoise des infrastructures"
                src="https://www.sqi.gouv.qc.ca/typo3conf/ext/sqi_site_package/Resources/Public/Images/piv-pied-page-last.svg"
            /></a>
          </div>
          <div lang="fr">
            <p>
              <a
                href="https://www.quebec.ca/"
                target="_blank"
                class="copyright"
                rel="noreferrer noopener"
                >© Gouvernement du Québec,&nbsp;</a
              >{{ today | date: 'yyyy' }}.
            </p>
          </div>
        </div>
      </div>
    </section>
  </ng-template>

  <ng-template [ngIf]="isDisplayingMap">
    <div class="footer-right" id="footer-id" *ngIf="!showSearchBar">
      <span class="order2">
        <span class="footer-text">
          <a
            rel="noopener noreferrer"
            alt="('externallinks' | translate)"
            href="{{ 'footer.url-conditions' | translate }}"
            target="_blank"
            >{{ 'footer.conditions' | translate }}</a
          >
        </span>
        <span class="footer-text"> | </span>
        <span class="footer-text">
          <a
            rel="noopener noreferrer"
            alt="('externallinks' | translate)"
            href="{{ 'footer.url-ministry' | translate }}"
            target="_blank"
            >{{ 'footer.ministry' | translate }}</a
          >
        </span>
        <span class="footer-text"> | </span>
        <span class="footer-text">
          <a
            rel="noopener noreferrer"
            alt="('externallinks' | translate)"
            href="{{ 'footer.url-gov' | translate }}"
            target="_blank"
            >{{ 'footer.gov' | translate }}{{ today | date: 'yyyy' }}</a
          >
        </span>
      </span>
    </div>

    <div class="footer-mobile" *ngIf="showSearchBar">
      <div class="icone" (click)="togglePanel()">
        <img
          *ngIf="expansionPanel?.expanded"
          src="assets/icons/arrow-down.png"
          alt="Flèche bas"
          class="arrow-icon"
        />
        <img
          *ngIf="!expansionPanel?.expanded"
          src="assets/icons/arrow-up.png"
          alt="Flèche haut"
          class="arrow-icon"
        />
      </div>

      <mat-expansion-panel #expansionPanel (afterCollapse)="onPanelClose()">
        <mat-expansion-panel-header>
          <div class="search-bar-placeholder">
            <ng-container *ngTemplateOutlet="searchBarTemplate"></ng-container>
          </div>
        </mat-expansion-panel-header>

        <div class="sidenav-placeholder">
          <ng-container *ngTemplateOutlet="sidenavTemplate"></ng-container>
        </div>

        <div class="footer-right-mobile" id="footer-id">
          <span class="order2">
            <span class="footer-text">
              <a
                rel="noopener noreferrer"
                alt="('externallinks' | translate)"
                href="{{ 'footer.url-conditions' | translate }}"
                target="_blank"
                >{{ 'footer.conditions' | translate }}</a
              >
            </span>
            <span class="footer-text"> | </span>
            <span class="footer-text">
              <a
                rel="noopener noreferrer"
                alt="('externallinks' | translate)"
                href="{{ 'footer.url-ministry' | translate }}"
                target="_blank"
                >{{ 'footer.ministry' | translate }}</a
              >
            </span>
            <br />
            <span class="footer-text">
              <a
                rel="noopener noreferrer"
                alt="('externallinks' | translate)"
                href="{{ 'footer.url-gov' | translate }}"
                target="_blank"
                >{{ 'footer.gov' | translate }}{{ today | date: 'yyyy' }}</a
              >
            </span>
          </span>
        </div>
      </mat-expansion-panel>
    </div>
  </ng-template>
</footer>
